import JourneyDetailsAddOns from './JourneyDetailsAddOns';

export default JourneyDetailsAddOns;
